import {ZipAndCityInterface} from "./zip-and-city_interface";

class ZipCitySuggestion {

    /**
     * @param element
     * @param shippingAddress
     */
    constructor(
        element,
        shippingAddress = false
    ) {
        this.element = element;
        this.shippingAddress = shippingAddress;

        this.init();
    }

    /**
     * @returns {void}
     */
    init() {
        this.setEventsToElement();
    }

    /**
     * @returns {void}
     */
    setEventsToElement() {
        this.element.addEventListener(
            'click',
            () => this.onSuggestionClick()
        );
    }

    /**
     * @returns {void}
     */
    onSuggestionClick() {
        const suggestionZip = this.element.getAttribute(ZipAndCityInterface.DataAttributeZip);
        const suggestionCity = this.element.getAttribute(ZipAndCityInterface.DataAttributeCity);

        if (suggestionZip === null || suggestionCity === null) {

            return;
        }

        this.handleSuggestionClick(
            suggestionZip,
            suggestionCity
        );
    }

    /**
     * @param suggestionZip
     * @param suggestionCity
     * @returns {void}
     */
    handleSuggestionClick(
        suggestionZip,
        suggestionCity
    ) {
        const zipElement = this.getCheckoutFormZipElement();
        const cityElement = this.getCheckoutFormCityElement();

        if (zipElement === null || cityElement === null) {

            return;
        }

        zipElement.value = suggestionZip;
        cityElement.value = suggestionCity;

        this.hideSuggestions();
    }

    /**
     * @returns {HTMLElement|null}
     */
    getCheckoutFormZipElement() {

        if (this.shippingAddress) {

            return document.getElementById(ZipAndCityInterface.SelectorCheckoutAddressShippingZip);
        }

        return document.getElementById(ZipAndCityInterface.SelectorCheckoutAddressZip);
    }

    /**
     * @returns {HTMLElement|null}
     */
    getCheckoutFormCityElement() {

        if (this.shippingAddress) {

            return document.getElementById(ZipAndCityInterface.SelectorCheckoutAddressShippingCity);
        }

        return document.getElementById(ZipAndCityInterface.SelectorCheckoutAddressCity);
    }

    /**
     * Hides the suggestion container
     *
     * @returns {void}
     */
    hideSuggestions() {
        const suggestionContainers = this.getSuggestionContainers();

        if (suggestionContainers === null) {

            return;
        }

        // Iterate over the suggestion containers and hide them
        suggestionContainers.forEach(function (suggestionContainer) {

            suggestionContainer.style.display = 'none';
        })
    }

    /**
     * @returns {HTMLElement}
     */
    getSuggestionContainers() {

        if (this.shippingAddress === true) {

            return [
                document.getElementById(ZipAndCityInterface.SelectorShippingAddressCitySuggestionContainer),
                document.getElementById(ZipAndCityInterface.SelectorShippingAddressZipSuggestionContainer)
            ]

        }

        return [
            document.getElementById(ZipAndCityInterface.SelectorAddressCitySuggestionContainer),
            document.getElementById(ZipAndCityInterface.SelectorAddressZipSuggestionContainer)
        ]
    }
}
export default ZipCitySuggestion;